// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"3df2d88e","383":"9e8f4b46","414":"fcafe6ba","544":"9083e310","708":"8197f4af","787":"b72a7e64","991":"b6583572"}[chunkId] + ".chunk.js";
};